import {DocPrix} from './DocPrix';
export class Oui {

	public docPrix: DocPrix;

	constructor() { 
		 		this.docPrix = new DocPrix();
 
	}
}
